// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__23wWn","inputDescription":"styles_inputDescription__IvQWg"};